import React from "react";
import { withTranslation } from "react-i18next";

class Schedule extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
            apiToken: process.env.REACT_APP_API_TOKEN,
            error: null,
            isLoaded: false,
            hours: []
        };
    }

    componentDidMount() {
        this.fetchHours('/tyres/adherent_informations');
    }

    setHours(hours) {
        this.setState({
            isLoaded: true,
            hours: hours,
        });
    }

    applyFilters(pageLink) {
        pageLink += `?token=${this.state.apiToken}`;
        pageLink += `&adherent_code=${this.props.adherentCode}`;
        return pageLink;
    }

    fetchHours(pageLink) {
        pageLink = this.applyFilters(pageLink);
        fetch(this.state.apiUrl + pageLink, {
            method: 'GET',
            redirect: 'follow',
            headers: new Headers({ 'accept': 'application/ld+json' })
        }).then(
            response => response.json()
        ).then(
            data => this.setHours(data.hours),
            error => this.setState({ isLoaded: true, error })
        )
    }

    renderDay(day) {
        let hours;
        let classes = "day-wrapper";
        if (day[1]["exception"]) {
            if (day[1]["exception"]["isOpen"] === false) {
                hours = this.props.t('exceptionally closed');
                classes += " closed"
            }
            else {
                hours = day[1]["exception"]["hours"] + " " + this.props.t('exceptionally');
                classes += " exception"
            }
        }
        else {
            if (day[1]["schedule"] === 'closed') {
                hours = this.props.t('closed')
            }
            else {
                hours = day[1]["schedule"];
            }
        }
        return (
            <div className={classes}>
                <span className="day">
                    {this.props.t(day[0])}
                </span>
                <span className="hours">
                    {hours}
                </span>
            </div>
        )
    }

    render() {
        const { error, isLoaded, hours } = this.state;

        if (error) {
            return (
                <div className="adherents-infos adherents-infos-hours">
                    <div className="adherents-infos-hours-wrapper">
                        <h2 className="h2">{this.props.t('schedules')}</h2>
                        <div className="error-message">
                            {this.props.t('error')}
                        </div>
                    </div>
                </div>
            );
        }

        if (!isLoaded) {
            return (
                <div>{this.props.t('loading')}</div>
            );
        }

        let hoursList = Object.entries(hours).map((day) =>
            this.renderDay(day)
        );

        return (
            <div className="adherents-infos adherents-infos-hours">
                <div className="adherents-infos-hours-wrapper">
                    <h2 className="h2">{this.props.t('schedules')}</h2>
                    <div className="opening-hours">
                        {hoursList}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Schedule);
